import { ReactNode } from 'react';
import { Div } from '@gaiads/telia-react-component-library';
import styles from './OrderFlowLayout.module.scss';

interface OrderFlowLayoutProps {
  children: ReactNode;
}

const OrderFlowLayout = ({ children }: OrderFlowLayoutProps) => {
  return <Div className={styles['order-flow-wrapper']}>{children}</Div>;
};

export default OrderFlowLayout;
